import { Vector2 } from "three";
export class Scene {
    constructor(posx, posy, w, h, parenthtmlelement) {
        this.objects = [];
        this.canvas = null;
        this.ctx = null;
        this.parenthtmlelement = null;
        this.canvas = document.createElement("canvas");
        this.canvas.oncontextmenu = function () {
            return false;
        };
        this.canvas.style.width = w + "px";
        this.canvas.style.height = h + "px";
        this.canvas.width = w;
        this.canvas.height = h;
        this.canvas.style.position = "absolute";
        this.canvas.style.left = posx + "px";
        this.canvas.style.top = posy + "0px";
        this.canvas.style.pointerEvents = "none";
        this.parenthtmlelement = parenthtmlelement;
        this.parenthtmlelement.appendChild(this.canvas);
        this.ctx = this.canvas.getContext("2d");
    }
    receiveEvents(b) {
        if (b) {
            this.canvas.style.pointerEvents = "auto";
        }
        else {
            this.canvas.style.pointerEvents = "none";
        }
    }
    render() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        for (let i = 0; i < this.objects.length; i++) {
            this.objects[i].render();
        }
    }
    pick(mx, my) {
        for (let i = 0; i < this.objects.length; i++) {
            if (this.objects[i].pick(mx, my) && !this.objects[i].hidden) {
                return this.objects[i];
            }
        }
        return null;
    }
    createCrosshair(x, y, s) {
        const ch = new Crosshair(this.ctx, x, y, s);
        this.objects.push(ch);
        return ch;
    }
    createLsmButton(x, y, s) {
        const img = new Image();
        img.src =
            "data:image/png;base64,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";
        const lsmb = new Button(this.ctx, x, y, s, img);
        this.objects.push(lsmb);
        return lsmb;
    }
    createLine(m, q, linewidth, linestyle) {
        const line = new Line(this.ctx, m, q, 3, "#ff0000");
        this.objects.push(line);
        return line;
    }
    createCenteredTargetCross(w, h, linewidth) {
        const ctc = new CenteredTargetCross(this.ctx, w, h, linewidth);
        this.objects.push(ctc);
        return ctc;
    }
    remove(obj) {
        for (let i = 0; i < this.objects.length; i++) {
            if (this.objects[i] == obj) {
                this.objects.splice(i);
                this.render();
                return true;
            }
        }
        return false;
    }
    destroy() {
        this.parenthtmlelement.removeChild(this.canvas);
    }
}
export class Crosshair {
    constructor(ctx, x, y, s) {
        this.position = null;
        this.scale = 1;
        this.ctx = null;
        this.hidden = false;
        this.moveable = false;
        this.crosshairstyle = 0;
        this.color = "white";
        this.ctx = ctx;
        this.position = new Vector2(x, y);
        this.scale = s;
    }
    render() {
        if (!this.hidden)
            this.drawCrossHair();
    }
    changeStyle() {
        this.crosshairstyle = (this.crosshairstyle + 1) % 4;
    }
    drawCrossHair() {
        //draw circle
        this.ctx.beginPath();
        this.ctx.arc(this.position.x, this.position.y, this.scale, 0, 2 * Math.PI, false);
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = this.color;
        this.ctx.shadowBlur = 2;
        this.ctx.shadowColor = "black";
        this.ctx.stroke();
        this.ctx.shadowBlur = 0;
        let margin;
        switch (this.crosshairstyle) {
            case 0:
                this.ctx.beginPath();
                this.ctx.strokeStyle = "rgba(0,0,0,0.3)";
                margin = 0.2 * this.scale;
                this.ctx.lineWidth = 1;
                this.ctx.moveTo(this.position.x - this.scale + margin, this.position.y);
                this.ctx.lineTo(this.position.x + this.scale - margin, this.position.y);
                this.ctx.moveTo(this.position.x, this.position.y - this.scale + margin);
                this.ctx.lineTo(this.position.x, this.position.y + this.scale - margin);
                this.ctx.stroke();
                break;
            case 1:
                this.ctx.beginPath();
                this.ctx.strokeStyle = "rgba(255,255,255,0.3)";
                margin = 0.2 * this.scale;
                this.ctx.lineWidth = 1;
                this.ctx.moveTo(this.position.x - this.scale + margin, this.position.y);
                this.ctx.lineTo(this.position.x + this.scale - margin, this.position.y);
                this.ctx.moveTo(this.position.x, this.position.y - this.scale + margin);
                this.ctx.lineTo(this.position.x, this.position.y + this.scale - margin);
                this.ctx.stroke();
                break;
            case 2:
                this.ctx.beginPath();
                this.ctx.strokeStyle = "rgba(0,0,0,0.7)";
                this.ctx.lineWidth = 1;
                this.ctx.moveTo(this.position.x - 1, this.position.y - 1);
                this.ctx.lineTo(this.position.x + 1, this.position.y - 1);
                this.ctx.moveTo(this.position.x - 1, this.position.y);
                this.ctx.lineTo(this.position.x + 1, this.position.y);
                this.ctx.moveTo(this.position.x - 1, this.position.y + 1);
                this.ctx.lineTo(this.position.x + 1, this.position.y + 1);
                this.ctx.stroke();
                break;
            case 3:
                this.ctx.beginPath();
                this.ctx.strokeStyle = "rgba(255,255,255,0.7)";
                this.ctx.lineWidth = 1;
                this.ctx.moveTo(this.position.x - 1, this.position.y - 1);
                this.ctx.lineTo(this.position.x + 1, this.position.y - 1);
                this.ctx.moveTo(this.position.x - 1, this.position.y);
                this.ctx.lineTo(this.position.x + 1, this.position.y);
                this.ctx.moveTo(this.position.x - 1, this.position.y + 1);
                this.ctx.lineTo(this.position.x + 1, this.position.y + 1);
                this.ctx.stroke();
                break;
        }
    }
    pick(x, y) {
        return Math.abs(x - this.position.x) < this.scale && Math.abs(y - this.position.y) < this.scale;
    }
    changeColor(color) {
        this.color = color;
        this.render();
    }
    hide() {
        this.hidden = true;
        this.render();
    }
    show() {
        this.hidden = false;
        this.render();
    }
}
export class Button {
    constructor(ctx, x, y, s, img) {
        this.position = null;
        this.scale = 1;
        this.ctx = null;
        this.hidden = false;
        this.moveable = false;
        this.crosshairstyle = 0;
        this.image = null;
        this.color = "white";
        this.ctx = ctx;
        this.position = new Vector2(x, y);
        this.scale = s;
        this.image = img;
    }
    render() {
        if (!this.hidden)
            this.drawButton();
    }
    drawButton() {
        this.ctx.shadowColor = "#000";
        this.ctx.shadowBlur = 2;
        this.image.style.width = "20px";
        this.image.style.height = "20px";
        this.image.width = 20;
        this.image.height = 20;
        this.ctx.drawImage(this.image, this.position.x + 25, this.position.y - 45, 20, 20);
        this.ctx.shadowBlur = 0;
    }
    pick(x, y) {
        return Math.abs(x - (this.position.x + 25)) < this.scale && Math.abs(y - (this.position.y - 45)) < this.scale;
    }
    hide() {
        this.hidden = true;
        this.render();
    }
    show() {
        this.hidden = false;
        this.render();
    }
}
export class Line {
    constructor(ctx, p1, p2, linewidth, linestyle) {
        this.linewidth = 1;
        this.ctx = null;
        this.hidden = false;
        this.ctx = ctx;
        this.p1 = p1;
        this.p2 = p2;
    }
    render() {
        if (!this.hidden)
            this.drawLine();
    }
    drawLine() {
        this.ctx.strokeStyle = "rgba(255,0,0,0.6)";
        this.ctx.shadowColor = "rgba(255,255,255,1.0)";
        this.ctx.shadowBlur = 1;
        this.ctx.beginPath();
        this.ctx.moveTo(this.p1.x, this.p1.y);
        this.ctx.lineTo(this.p2.x, this.p2.y);
        this.ctx.stroke();
    }
    pick(x, y) {
        return false;
    }
    hide() {
        this.hidden = true;
        this.render();
    }
    show() {
        this.hidden = false;
        this.render();
    }
}
export class CenteredTargetCross {
    constructor(ctx, w, h, linewidth) {
        this.linewidth = 1;
        this.ctx = null;
        this.hidden = false;
        this.ctx = ctx;
        this.w = w;
        this.h = h;
        this.linewidth = linewidth;
    }
    render() {
        if (!this.hidden)
            this.drawLine();
    }
    drawLine() {
        this.ctx.lineWidth = this.linewidth;
        this.ctx.strokeStyle = "rgba(0,0,0,0.3)";
        this.ctx.beginPath();
        this.ctx.moveTo(this.ctx.canvas.width / 2, this.ctx.canvas.height / 2 - this.h / 2);
        this.ctx.lineTo(this.ctx.canvas.width / 2, this.ctx.canvas.height / 2 + this.h / 2);
        this.ctx.moveTo(this.ctx.canvas.width / 2 - this.w / 2, this.ctx.canvas.height / 2);
        this.ctx.lineTo(this.ctx.canvas.width / 2 + this.w / 2, this.ctx.canvas.height / 2);
        this.ctx.stroke();
    }
    pick(x, y) {
        return false;
    }
    hide() {
        this.hidden = true;
        this.render();
    }
    show() {
        this.hidden = false;
        this.render();
    }
}
//# sourceMappingURL=canvas.js.map